import { Checkbox } from '@/components/ui'
import { CARD_NETWORKS, CardNetwork } from '@/common/models/gamification'

interface CardNetworkCheckboxesProps {
  /** Selected networks; undefined/empty means "all networks". */
  value: CardNetwork[] | undefined
  onChange: (next: CardNetwork[] | undefined) => void
}

/**
 * Card-network multi-select checkbox grid, shared by the TOPUP and CONTINUOUS_TOPUP config editors.
 * Emits `undefined` when nothing is selected (backend treats null/absent as "all networks").
 */
export const CardNetworkCheckboxes = ({
  value,
  onChange,
}: CardNetworkCheckboxesProps) => {
  const selected = value ?? []

  const toggle = (network: CardNetwork, checked: boolean) => {
    const next = checked
      ? [...selected, network]
      : selected.filter((n) => n !== network)
    onChange(next.length ? next : undefined)
  }

  return (
    <div>
      <div className="text-body-medium text-monochrome-1 mb-2">
        Card networks{' '}
        <span className="text-monochrome-2">(none selected = all)</span>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {CARD_NETWORKS.map((network) => (
          <label
            key={network}
            className="flex items-center gap-2 cursor-pointer"
          >
            <Checkbox
              checked={selected.includes(network)}
              onCheckedChange={(checked) => toggle(network, !!checked)}
            />
            <span className="text-body-medium text-monochrome-2">
              {network}
            </span>
          </label>
        ))}
      </div>
    </div>
  )
}
